import { Tag } from "@blueprintjs/core";
import { Popover2InteractionKind, Tooltip2 } from "@blueprintjs/popover2";

export type SharedModelTagVariant = "withMe" | "byMe";

interface SharedModelTagProps {
  variant: SharedModelTagVariant;
  shareCount?: number;
}

function tooltipContent(variant: SharedModelTagVariant, shareCount?: number): string {
  if (variant === "withMe") {
    return "Someone shared this model with you";
  }
  if (shareCount && shareCount > 0) {
    return `You shared this with ${shareCount} ${shareCount === 1 ? "person" : "people"}`;
  }
  return "You shared this model with others";
}

export default function SharedModelTag(props: SharedModelTagProps) {
  const { variant, shareCount } = props;
  const label = variant === "withMe" ? "" : `${shareCount}`;

  return (
    <Tooltip2
      content={tooltipContent(variant, shareCount)}
      interactionKind={Popover2InteractionKind.HOVER}
      popoverClassName="tooltip-content text-tooltip"
      hoverCloseDelay={200}
      placement="right"
    >
      <Tag minimal round icon={variant === "byMe" ? "people" : "eye-open"}>
        {label}
      </Tag>
    </Tooltip2>
  );
}
